import React, { useRef, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { FiX } from "react-icons/fi";
import { FaRegCalendarAlt } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const AddTerminationModal = ({ show, handleClose }) => {
  const [noticeDate, setNoticeDate] = useState(null);
  const [resignationDate, setResignationDate] = useState(null);
  const noticeDateRef = useRef(null);
  const resignationDateRef = useRef(null);

  return (
    <Modal show={show} onHide={handleClose} centered>
      {/* HEADER */}
      <div
        style={{
          padding: "16px 20px",
          borderBottom: "1px solid #e5e7eb",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h5 style={{ margin: 0, fontWeight: "600" }}>Edit Termination</h5>

        <FiX
          onClick={handleClose}
          style={{
            cursor: "pointer",
            fontSize: "18px",
            color: "#6b7280",
          }}
        />
      </div>

      {/* BODY */}
      <Modal.Body style={{ padding: "20px" }}>
        {/* Employee */}
        <Form.Group style={{ marginBottom: "15px" }}>
          <Form.Label>Terminated Employee</Form.Label>
          <Form.Select style={inputStyle}>
            <option>Select</option>
            <option>vamsi kumar</option>

          </Form.Select>
        </Form.Group>

        {/* Type */}
        <Form.Group style={{ marginBottom: "15px" }}>
          <Form.Label>Termination Type</Form.Label>
          <Form.Select style={inputStyle}>
            <option>Select</option>
            <option>Lack of Skills</option>
            <option>Insubrdination</option>


          </Form.Select>
        </Form.Group>

        {/* Notice Date */}
        <Form.Group style={{ marginBottom: "15px" }}>
          <Form.Label>Notice Date</Form.Label>

          <div style={dateWrapper}>
            <DatePicker
              selected={noticeDate}
              onChange={(date) => setNoticeDate(date)}
              placeholderText="dd/mm/yyyy"
              dateFormat="dd-MM-yyyy"
              className="form-control"
              ref={noticeDateRef}
              style={dateInput}
            />
            {/* <FaRegCalendarAlt
              style={calendarIcon}
              onClick={() => noticeDateRef.current?.setOpen(true)}
            /> */}
          </div>
        </Form.Group>

        {/* Reason */}
        <Form.Group style={{ marginBottom: "15px" }}>
          <Form.Label>Reason</Form.Label>
          <Form.Control as="textarea" rows={3} style={inputStyle} />
        </Form.Group>

        {/* Resignation Date */}
        <Form.Group>
          <Form.Label>Resignation Date</Form.Label>

          <div style={dateWrapper}>
            <DatePicker
              selected={resignationDate}
              onChange={(date) => setResignationDate(date)}
              placeholderText="dd/mm/yyyy"
              dateFormat="dd-MM-yyyy"
              className="form-control"
              ref={resignationDateRef}
              style={dateInput}
            />
            {/* <FaRegCalendarAlt
              style={calendarIcon}
              onClick={() => resignationDateRef.current?.setOpen(true)}
            /> */}
          </div>
        </Form.Group>
      </Modal.Body>

      {/* FOOTER */}
      <div
        style={{
          padding: "15px 20px",
          borderTop: "1px solid #e5e7eb",
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
        }}
      >
        <Button
          variant="light"
          onClick={handleClose}
          style={{
            border: "1px solid #e5e7eb",
            padding: "6px 16px",
          }}
        >
          Cancel
        </Button>

        <Button
          style={{
            backgroundColor: "#f97316",
            border: "none",
            padding: "6px 18px",
          }}
        >
          Add Termination
        </Button>
      </div>
    </Modal>
  );
};

export default AddTerminationModal;

// ✅ Styles
const inputStyle = {
  borderRadius: "6px",
  fontSize: "14px",
  padding: "8px 10px",
};

const dateWrapper = {
  position: "relative",
};

const dateInput = {
  paddingRight: "35px",
};

const calendarIcon = {
  position: "absolute",
  right: "10px",
  top: "50%",
  transform: "translateY(-50%)",
  color: "#6b7280",
};
